// origings is a string with comma separated origins e.g 'http://localhost:3000,http://example.com'
function postMessageToParent (message, origins) {
  const originArray = origins.split(',')

  originArray.forEach(origin => {
    window.parent.postMessage(message, origin)
  })
}

export { postMessageToParent }
